import type { Part } from '@/model';
import { formatDuration } from '@/ui';
import { object } from './call-wire';

export function callDuration(seconds: number): string {
  // The shared clock style is identical in both supported languages.
  return formatDuration(seconds*1000,{locale:'en',style:'clock'});
}

export function callRecordText(part: Part, translate: (key: string, values?: Record<string, unknown>) => string): string | null {
  if (part.type !== 'system' || part.event !== 'call') return null;
  const record = object(part.call);
  const video = record?.kind === 'video';
  const kind = video ? 'video' : 'voice', suffix = video ? 'Video' : 'Voice';
  if (record?.outcome === 'completed' && typeof record.duration_s === 'number' && Number.isSafeInteger(record.duration_s)) return translate(`record.${kind}Duration`, { duration: callDuration(record.duration_s) });
  if (['missed', 'declined', 'cancelled'].includes(String(record?.outcome))) return translate(`record.${record!.outcome}${suffix}`);
  return translate(`record.${kind}`);
}
